export const DOM_REFS = {
  USER_SIGN_IN: {
    FORM: '#login-form',
    EMAIL: '#user_email',
    PASSWORD: '#user_password',
    LOGIN: '#login-button',
    FLASH_MESSAGE: '#flash-container',
  },
  USER_SIGN_UP: {
    SIGN_UP: '#signup-button',
    FORM: '#signup-form',
    SIGNUP_PROMO_FORM: '#new_user_registration_form',
  },
};

export const TERMS_STATE = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE: 'HIDE',
  SHOW_ERROR: 'SHOW_ERROR',
};

export const PAGES = {
  LOGIN: 'LOGIN',
  SIGNUP: 'SIGNUP',
};
